<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Leaderboard
          </h4>

          <span class="subheading">
            <p>The public leaderboard tracks the best submission from each solver, as scored by mean average precision (mAP). You can also see secondary metrics such as mAP on common vs. rare objects. Click the header to sort by a given metric. If your best submission is in the top 50 submissions from all solvers, it will appear on the <v-btn color="primary" dark flat to="leaderboard" class="mx-0 my-0">Leaderboard</v-btn></p>
          
          </span>
          <v-divider></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0 my-4" to="tour6">Next</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour5',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour3 component mounted')
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Tour/Tour5.vue